import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { REMOVE_SCRIPT } from '../../../apollo/scripts.ts';

export const useScriptsSearch = () => {
  const [filter, setFilter] = useState<{ [key: string]: string | number | undefined }>({
    id: undefined,
    name: undefined,
  });
  const onChangeFilter = useCallback((value?: string, type?: string) => {
    setFilter((prev) => {
      const next = {
        id: type === 'id' ? (value?.length ? Number(value) : undefined) : undefined,
        name: type === 'name' ? value : undefined,
      };

      if (prev.id === next.id && prev.name === next.name) {
        return prev;
      }

      return next;
    });
  }, []);

  return { filter, onChangeFilter };
};

export const useRemoveScript = (afterRemove?: () => void) => {
  const [isModalOpen, setModal] = useState(false);
  const [remove] = useMutation(REMOVE_SCRIPT);
  const onRemove = (id: number) => {
    const promise = remove({
      variables: {
        input: {
          id,
        },
      },
    });

    toast.promise(promise, {
      pending: `Deleting Script...`,
      success: `Script deleted`,
    });

    promise.then(() => {
      if (afterRemove) afterRemove();
    });
  };

  const onCloseModal = () => setModal(false);
  const onOpenModal = () => setModal(true);

  return {
    onRemove,
    onCloseModal,
    onOpenModal,
    isModalOpen,
  };
};
